import React, { Fragment } from "react";

export default (
  <>
    <path d="M20.9 12.5c-.7 0-1.3.5-1.3 1.2V20c0 1-.8 1.5-1.8 1.5H4.2c-1.1 0-1.5-.5-1.5-1.5V6.3c0-.9.5-2 1.5-2h7.7c.7 0 1.2-.6 1.2-1.3 0-.6-.5-1.3-1.2-1.3H4.2c-2.3 0-4 2.1-4 4.5V20c0 2.4 1.8 4 4 4h13.6c2.3 0 4.3-1.6 4.3-4v-6.2c0-.7-.6-1.3-1.2-1.3z" />
    <path d="M24.1 1.2c0-.2 0-.3-.1-.5-.1-.3-.4-.5-.7-.7h-7.5c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3h4l-9.7 9.7c-.5.5-.5 1.3 0 1.8.2.2.6.4.9.4s.6-.1.9-.4l9.7-9.7v4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3l-.1-7.2z" />
  </>
);
